<script>
export default {
  name: "FilePromptComponent",
  props: {
    prompt: {
      type: String,
      required: true
    },
    promptMobile: {
      type: String,
      required: true
    },
    objectIndex: {
      type: Number,
      required: true
    }
  }
}
</script>

<template>
  <div class="prompt">
    <div v-html="prompt"></div>
  </div>
  <div class="prompt-mobile">
    <div class="prompt-mobile-title">Варианты документов:</div>
    <div v-html="promptMobile"></div>
  </div>
  <div v-if="objectIndex === 0" class="info-text">
    Фото документа, дающего право на <router-link to="/information/skidki">скидку</router-link>, вы можете подгрузить здесь, с документами первого объекта оценки.
  </div>
</template>

<style scoped>

.prompt {
  margin-bottom: 10px;
}

.prompt :deep(li) {
  padding-bottom: 3px;
  font-size: 18px;
  margin-bottom: 10px;
}

.prompt li {
  font-size: 18px;
  padding-bottom: 3px;
  line-height: 1.5em;
}

.prompt-mobile {
  display: none;
  margin-bottom: 10px;
}

.prompt-mobile-title {
  margin-bottom: 10px;
}

.info-text {
  padding-bottom: 3px;
  font-size: 18px;
  margin-bottom: 10px;
  font-weight: 500;
}

.info-text a {
  color: #3294ca;
  text-decoration: underline;
}

.info-text a:hover {
  text-decoration: none;
}

@media (max-width: 768px) {

  .prompt {
    display: none;
  }

  .prompt-mobile {
    display: block;
  }

  .info-text {
    font-size: 14px;
    margin-bottom: 5px;
  }

}

</style>
